import {
  CompanyAttributes,
  DocumentClassAttributes,
  EmissionPointAttributes,
  MaterialStockAttributes,
  OrderAttributes,
  OrderDetailAttributes,
  OrderExtraStatusAttributes,
  SubRouteAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonModule, DecimalPipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule, Sort } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, Router } from "@angular/router";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { ReprintButtonComponent } from 'app/modules/shared/reprint-button/reprint-button.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import {
  IPaginationResultFrequencies,
  IRequestResult,
} from "app/common/interfaces";
import { AuthService } from "app/core/auth/auth.service";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import {
  ExportFileFormat,
  ExportRange,
} from "app/layout/export-overlay/tasks/core/export-task.enum";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { LogModalComponent } from "app/modules/shared/log-modal/log-modal.component";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { BusinessPartnerDisplayComponent } from "app/shared/components/business-partner-display/business-partner-display.component";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { DateHelper } from "app/utils/date.helper";
import { validateOrdersByAction } from "app/utils/document-class-validation";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  skip,
  Subject,
  Subscription,
  take,
  takeUntil,
} from "rxjs";
import { CompanyService } from "../../configuration/company/company.service.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { DocumentRangeService } from "../../document/document-range/document-range.service";
import { EmissionPointService } from "../../document/emission-point/emission-point.service";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "../../filters/documents-filters/documents-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { MaterialsManagementFiltersComponent } from "../../filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { OrderCustomerService } from "../../reports/historic/order-customer/order-customer.service";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { TypeRejectEnum } from "../../shared/form-appro-reject/type-document.enum";
import { ChangeTripOrderComponent } from "../change-trip-order/change-trip-order.component";
import { MasterUserInterface } from "../order-generate/interfaces/master-user.interface";
import { OrdersListService } from "../order-list-components/order-list.service";
import { OrdersCreationService } from "../quotation-generate/quotation-generate.service";
import { SelectOrderDetailComponent } from "../select-order-detail/select-order-detail.component";
import { UpdateOrderService } from "../update-order/update-order.service";
import { OrderDeliveryCustomerExport } from "./exports/order-delivery.export";
import { IUpdateOrder, IUserApprovalResponse } from "../update-order/interfaces/update-order.interface";
import { UnitMeasureDisplayComponent } from "../../../../shared/components/unit-measure-display/unit-measure-display.component";

@Component({
  selector: "app-delivery-list",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatRadioModule,
    FormatOtherDateHourPipe,
    MatAutocompleteModule,
    FilterComponent,
    DecimalFormatPipe,
    DocumentFlowButtonComponent,
    FilterSectionComponent,
    StatusFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    MaterialsManagementFiltersComponent,
    UserRouteDisplayComponent,
    BusinessPartnerDisplayComponent,
    HoverMenuDirective,
    CompanyCurrencyPipe,
    ReprintButtonComponent,
    UnitMeasureDisplayComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    DecimalPipe,
    OrderDeliveryCustomerExport,
  ],
  templateUrl: "./delivery-list.component.html",
  styleUrl: "./delivery-list.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class DeliveryListComponent implements OnDestroy {
  getCode = getCode;
  projectName = environment.projectName;
  StatusEnum = StatusEnum;
  OrderStatusERPEnum = OrderStatusERPEnum;
  type = DocumentTypeEnum.ENTREGA_SALIDA;

  private isInitialized = false;

  displayedColumns: string[] = [
    "det",
    "check",
    "status",
    "statusERP",
    "type",
    "trip",
    "routeUser",
    "businessPartner",
    "documentNumber",
    "class",
    //'date',
    "subTotal",
    //'surcharge', 'discount', 'tax',
    "total",
    "creation",
    //'documentStatus',
    "actions",
  ];
  dataSource = new MatTableDataSource<OrderAttributes>([]);

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  selection = new SelectionModel<any>(true, []);
  selectedOrder: OrderAttributes | null = null;

  //DETAIL 1 Posiciones del pedido
  dataSourceDetail1 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail1") sortDetail1: MatSort;

  //DETAIL 2 Entrega
  displayedColumnsDetail2: string[] = [
    "material",
    "warehouse",
    "soldQuantity",
    "confirmedQuantity",
    "deliveredQuantity",
    "relatedDocuments",
  ];
  dataSourceDetail2 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail2") sortDetail2: MatSort;

  //DETAIL 3 Factura
  displayedColumnsDetail3: string[] = [
    "material",
    "warehouse",
    "soldQuantity",
    "invoicedQuantity",
    "invoicedPrice",
    "invoicedDiscount",
    "invoice",
  ];
  dataSourceDetail3 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail3") sortDetail3: MatSort;

  companyList: CompanyAttributes[] = [];
  UMPActive: boolean;

  //Filter
  selectedStartDate: Date;
  selectedEndDate: Date;
  dateRange: FormGroup;

  //Filter
  selectedStartDateEnd: Date;
  selectedEndDateEnd: Date;
  dateRangeDelivery: FormGroup;

  //Filter
  selectedStartDateLoad: Date;
  selectedEndDateLoad: Date;
  dateRangeLoad: FormGroup;

  // selectedStatusERP: number = 0;
  // Selección múltiple
  selectedStatusERP: number[] = [];

  // Controlador de búsqueda
  statusFilterCtrl = new FormControl();

  // Estados filtrados
  filteredStatusERP: BehaviorSubject<any[]> = new BehaviorSubject([]);

  // Estados de selección
  isStatusIndeterminate = false;
  isStatusChecked = false;

  private _onDestroy = new Subject<void>();

  // selectedDocumentClass: string = '0';
  selectedDocumentClass: string[] = [];
  filteredDocumentClasses: Subject<DocumentClassAttributes[]> = new Subject();
  documentClassMultiFilterCtrl: FormControl = new FormControl();
  isIndeterminateDocumentClass: boolean = false;
  isCheckedDocumentClass: boolean = false;
  private _onDestroyDocumentClass = new Subject<void>();

  selectedSeller: string = "0";
  selectedWithTravel: string[] = [];

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  isGlobalSynchronizeAvailable: boolean = false;

  orderStatusErpList = [
    { id: null, name: "Todos" },
    { id: 0, name: "Entrega pendiente" },
    { id: 4, name: "Error enviando a ERP" },
    { id: 1, name: "Entrega enviado a ERP" },
    { id: 2, name: "Entrega recibido por ERP" },
    { id: 3, name: "Entrega creada en ERP" },
  ];

  isOrderListTrip = environment.isOrderListTrip;

  @ViewChild("orderDetailUpdateConfirmationDialog")
  orderDetailUpdateConfirmationDialog!: TemplateRef<any>;

  routeList: SubRouteAttributes[] = [];
  filterRouteList: SubRouteAttributes[] = [];
  searchRoute = "";

  emissionPointList: EmissionPointAttributes[] = [];
  listFilteremissionPointList: EmissionPointAttributes[] = [];
  searchEmissionPoint = "";

  salesOfficeList: SalesOfficeAttributes[] = [];
  filterSalesOfficeList: SalesOfficeAttributes[] = [];
  searchSalesOffice = "";

  currentRoute = this.initializeRoute();
  currentAll = this.initializeAll();
  currentDownloadDay = this.initializeDownloadDay();

  @ViewChild("fileImportDialog") fileImportDialog!: TemplateRef<any>;
  @ViewChild("fileDayImportDialog") fileDayImportDialog!: TemplateRef<any>;
  dialogRefFile: MatDialogRef<any>;
  dialogDayFile: MatDialogRef<any>;

  interval;
  timeInterval = 60000 * 15;
  showInterval: boolean = false;

  //1
  fileToUpload: File;
  aux_file = false;

  //2
  fileToUploadAll: File;
  aux_file_all = false;

  //download
  totalItemsDay = 0;

  //popup
  @ViewChild("popupTemplate", { read: TemplateRef })
  popupTemplate!: TemplateRef<any>;
  isPopupVisible = false;
  popupText = null;
  popupStyle: any = {};

  selectedSoldTo: string = "0";
  soldToControl = new FormControl("");
  soldToList: any[] = [];
  soldToFilterSelected: any = null;

  selectedShipTo: string = "0";
  shipToControl = new FormControl("");
  shipToList: any[] = [];

  subs: Subscription[] = [];
  ordersToFilter: string[] = [];

  //BUSCADOR
  searchSubscription: Subscription;

  //Para filtros
  selectedStatuses: number[] = [];

  // Estados ERP
  selectedERPStatuses: number[] = [];

  selectedCustomerType: string[] = [];

  form: FormGroup;

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  constructor(
    private ordersListService: OrdersListService,
    private readonly updateOrderService: UpdateOrderService,
    private readonly ordersCreationService: OrdersCreationService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly warehouseService: WarehouseService,
    private readonly documentClassService: DocumentClassService,
    private readonly authService: AuthService,
    private readonly subRouteService: SubRouteService,
    private readonly documentRangeService: DocumentRangeService,
    private readonly emisionPointService: EmissionPointService,
    private readonly orderCustomerService: OrderCustomerService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private readonly cdr: ChangeDetectorRef,
    private orderDeliveryCustomerExport: OrderDeliveryCustomerExport,
    private viewContainerRef: ViewContainerRef,
    private readonly router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    const today = new Date();
    this.dateRange = this.fb.group({
      start: [today],
      end: [today],
    });
    this.dateRangeDelivery = this.fb.group({
      start: null,
      end: null,
    });
    this.dateRangeLoad = this.fb.group({
      start: null,
      end: null,
    });
    this.selectedStartDate = today;
    this.selectedEndDate = today;
    // this.selectedStartDate.setHours(0, 0, 0, 0);
    this.selectedEndDate.setHours(23, 59, 59, 999);

    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      end_startTrip: [],
      end_endTrip: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit(): void {
    this.onHandleSearch();

    this.subs.push(
      this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
        if (params["deliveryIds"]) {
          this.ordersToFilter = params["deliveryIds"]
            ? params["deliveryIds"].split(",")
            : [];
        }

        this.fetchCompanies();
        this.fetchDocumentClass();
        this.getListSeller();
        this.onFilter();
        this.isInitialized = true;
      })
    );
  }

  ngAfterViewInit(): void {
    this.documentClassMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroyDocumentClass))
      .subscribe(() => {
        this.filterDocumentClasses();
        this.setToggleAllCheckboxStateDocumentClass();
      });

    this.searchControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe((filterValue: string) => {
        if (this.isInitialized) {
          this.pageIndex = 1;
          this.search = filterValue;
          this.getList();
        }
      });

    this.filteredStatusERP.next(this.orderStatusErpList);
    this.statusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterStatusERP();
      });

    this.soldToControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe((value) => {
        if (!this.isInitialized) return;

        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.soldToList = [];
        this.soldToFilterSelected = null;
        this.getListSoldTo(value);
        this.getList();
      });

    this.shipToControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe((value) => {
        if (!this.isInitialized) return;

        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.shipToList = [];
        this.getListShipTo(value);
        this.getList();
      });
  }

  private filterDocumentClasses(): void {
    if (!this.documentClassesList) {
      return;
    }
    let search = this.documentClassMultiFilterCtrl.value;
    if (!search) {
      this.filteredDocumentClasses.next(this.documentClassesList);
      return;
    } else {
      search = search.toLowerCase();
    }
    const filtered = this.documentClassesList.filter((docClass) =>
      docClass.name.toLowerCase().includes(search)
    );
    this.filteredDocumentClasses.next(filtered);
  }

  onDocumentClassSelectionChange(selectedValues: string[]): void {
    this.selectedDocumentClass = selectedValues;
  }

  private setToggleAllCheckboxStateDocumentClass(): void {
    const selectedCount = this.selectedDocumentClass.length;
    const totalCount = this.documentClassesList.length;

    this.isCheckedDocumentClass =
      selectedCount > 0 && selectedCount === totalCount;
    this.isIndeterminateDocumentClass =
      selectedCount > 0 && selectedCount < totalCount;
  }

  filterStatusERP(): void {
    const search = this.statusFilterCtrl.value?.toLowerCase() || "";
    const filtered = this.orderStatusErpList.filter((os) =>
      os.name.toLowerCase().includes(search)
    );
    this.filteredStatusERP.next(filtered);
  }

  onStatusSelectionChange(selected: number[]): void {
    this.selectedStatusERP = selected;
    this.updateStatusSelectionState();
  }

  toggleSelectAllStatuses(isChecked: boolean): void {
    this.selectedStatusERP = isChecked
      ? this.orderStatusErpList.map((os) => os.id)
      : [];
    this.updateStatusSelectionState();
  }

  updateStatusSelectionState(): void {
    const total = this.orderStatusErpList.length;
    const selected = this.selectedStatusERP.length;
    this.isStatusChecked = total > 0 && selected === total;
    this.isStatusIndeterminate = selected > 0 && selected < total;
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  openInterval(event) {
    //para el html si se quiere activar o no
    if (!event) {
      this.showInterval = false;
    } else {
      this.showInterval = true;
    }
    this.onFilter();
  }

  onFilter() {
    if (this.showInterval) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.getList();

      this.interval = setInterval(() => {
        this.getList();
      }, this.timeInterval);
    } else {
      this.getList();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .pipe(skip(1), debounceTime(300))
      .subscribe((term) => {
        if (this.isInitialized) {
          this.applyFilter(term);
        }
      });
  }

  getList() {
    this.synchronizeDates();
    if (this.dateRangeDelivery) {
      this.synchronizeDatesDelivery();
    }
    if (this.dateRangeLoad) {
      this.synchronizeDatesLoad();
    }
    this.isGlobalSynchronizeAvailable = false;
    this.resetSelection();

    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sortDirection === "asc" ? "ASC" : "DESC";

    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: sortField,
      sortDirection: sortDirection,
    };

    let value: string | null = null;
    if (
      this.selectedWithTravel.includes("1") &&
      this.selectedWithTravel.includes("2")
    ) {
      value = "0"; // Filtrar por ambos
    } else if (this.selectedWithTravel.includes("1")) {
      value = "1"; // Filtrar solo por empleados
    } else if (this.selectedWithTravel.includes("2")) {
      value = "2"; // Filtrar solo por externos
    }

    const hasOrderIds = this.ordersToFilter && this.ordersToFilter.length > 0;
    const hasSearch = this.search && this.search.trim().length > 0;

    let dataFilter: IFilters = {
      type: this.type,

      startDate:
        !hasOrderIds && this.form.get("start")?.value
          ? DateHelper.getStartOfDay(this.form.get("start").value)
          : null,
      endDate:
        !hasOrderIds && this.form.get("end")?.value
          ? DateHelper.getEndOfDay(this.form.get("end").value)
          : !hasOrderIds && this.form.get("start")?.value
            ? DateHelper.getEndOfDay(this.form.get("start").value)
            : null,

      startTrip:
        !hasOrderIds && this.form.get("startTrip")?.value
          ? DateHelper.getStartOfDay(this.form.get("startTrip").value)
          : null,
      endTrip:
        !hasOrderIds && this.form.get("endTrip")?.value
          ? DateHelper.getEndOfDay(this.form.get("endTrip").value)
          : !hasOrderIds && this.form.get("startTrip")?.value
            ? DateHelper.getEndOfDay(this.form.get("startTrip").value)
            : null,

      end_startTrip:
        !hasOrderIds && this.form.get("end_startTrip")?.value
          ? DateHelper.getStartOfDay(this.form.get("end_startTrip").value)
          : null,
      end_endTrip:
        !hasOrderIds && this.form.get("end_endTrip")?.value
          ? DateHelper.getEndOfDay(this.form.get("end_endTrip").value)
          : !hasOrderIds && this.form.get("end_startTrip")?.value
            ? DateHelper.getEndOfDay(this.form.get("end_startTrip").value)
            : null,

      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value,
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,
      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,
      withTravel: value,
      materialGroupId: this.form.get("materialGroupId").value,
      materialId: this.form.get("materialId").value,

      status:
        !hasOrderIds && this.selectedStatuses?.length > 0
          ? this.selectedStatuses
          : null,
      statusERP:
        !hasOrderIds && this.selectedERPStatuses?.length > 0
          ? this.selectedERPStatuses
          : null,
      typeCustomer:
        !hasOrderIds && this.selectedCustomerType?.length > 0
          ? this.selectedCustomerType
          : null,

      ordersToFilter: hasOrderIds && !hasSearch ? this.ordersToFilter : null,
    };

    if (hasOrderIds && !hasSearch) {
      this.ordersToFilter = null;
    }

    this.ordersListService.findAllWithCount(options, dataFilter).subscribe({
      next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
        this.dataSource.data = res?.data?.data ?? [];
        this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message ||
            "Error al obtener la información de los pedidos.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  public toLocalISODate(date: Date, startOfDay: boolean) {
    const pad = (num: number) => num.toString().padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = startOfDay ? "00" : "23";
    const minutes = startOfDay ? "00" : "59";
    const seconds = startOfDay ? "00" : "59";

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${startOfDay ? "000" : "999"}`;
  }

  private getSortField(): keyof OrderAttributes {
    const sortFieldMapping: Record<string, keyof OrderAttributes> = {
      status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",
    };
    return sortFieldMapping[this.sortActive] || "creationDateTime";
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    this.getList();
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  isAllSelected() {
    const validRows = this.dataSource.data.filter((row) =>
      this.validateDataToEdit(row)
    );

    const numSelected = this.selection.selected.length;
    const numValidRows = validRows.length;
    return numSelected === numValidRows && numValidRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          if (this.validateDataToEdit(row)) this.selection.select(row);
        });
  }

  resetSelection() {
    this.selection.clear();
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1}`;
  }

  onCheckboxChange(event, element?): void {
    let auxSelected = this.selection.selected;
    this.isGlobalSynchronizeAvailable =
      auxSelected.length > 0 &&
      auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
        0;
  }

  async toggleDetails(order: OrderAttributes): Promise<void> {
    if (this.selectedOrder && this.selectedOrder._id === order._id) {
      this.closeDetails();
      return;
    }

    this.selectedOrder = order;
    this.dataSourceDetail1.data =
      this.selectedOrder.detail && this.selectedOrder.detail.length > 0
        ? this.selectedOrder.detail
        : [];
    this.dataSourceDetail1.sort = this.sortDetail1;
    this.setDeliveredAndInvoicedTables();
    this.handleEqualCodes(order);

    // Obtiene almacenes y clase de documento
    const orderStatusId = this.selectedOrder.statusId;
    if (orderStatusId != 0 && orderStatusId != 7 && orderStatusId != 8) {
      if (!this.selectedOrder["warehousesToUpdate"]) {
        const salesOffice: Partial<SalesOfficeAttributes> =
          await this.salesOfficeService
            .findOne(this.selectedOrder.salesOffice._id.toString())
            .toPromise()
            .then((res) => res.data);
        if (salesOffice && salesOffice.warehouses) {
          let filter = {
            officeWarehouse: salesOffice.warehouses.map((ware) => ware._id),
            company: [environment.companyId],
          };
          this.selectedOrder["warehousesToUpdate"] = await this.warehouseService
            .filterComboBox(filter)
            .toPromise()
            .then((res) => res.data);
          this.getStock(
            this.selectedOrder,
            this.selectedOrder["warehousesToUpdate"]
          );
        }
      }

      this.getDocumentClass(this.selectedOrder);
    }
  }

  setDeliveredAndInvoicedTables() {
    let detailAux2 =
      this.selectedOrder.detail?.length > 0
        ? this.selectedOrder.detail.filter(
            (od) =>
              [
                StatusEnum.ACTIVE,
                StatusEnum.ORDER_DELIVERED,
                StatusEnum.ORDER_PARTIAL_DELIVERED,
                StatusEnum.ORDER_DELIVERY_REJECTED,
              ].includes(od.statusId) && od.soldQuantity > 0
          )
        : [];

    this.dataSourceDetail2.data = detailAux2.map((detail) => ({
      ...detail,
      deliveryDocument:
        detail.relatedDocuments?.find((doc) => doc.type === "DELIVERY") || null,
    }));
    this.dataSourceDetail2.sort = this.sortDetail2;

    let detailAux3 =
      // this.selectedOrder.detail && this.selectedOrder.detail.length > 0 ? this.selectedOrder.detail.filter(od => od.statusId == StatusEnum.ACTIVE && od.soldQuantity > 0) : []
      this.selectedOrder.detail?.length > 0
        ? this.selectedOrder.detail.filter(
            (od) =>
              [
                StatusEnum.ACTIVE,
                StatusEnum.ORDER_DELIVERED,
                StatusEnum.ORDER_PARTIAL_DELIVERED,
                StatusEnum.ORDER_DELIVERY_REJECTED,
              ].includes(od.statusId) && od.soldQuantity > 0
          )
        : [];
    this.dataSourceDetail3.data = detailAux3.map((detail) => ({
      ...detail,
      invoiceDocument:
        detail.relatedDocuments?.find((doc) => doc.type === "INVOICE") || null,
    }));
    this.dataSourceDetail3.sort = this.sortDetail3;
  }

  sortData(sort: Sort, tab) {
    let dataTable = this.dataSourceDetail1.data.slice();
    if (tab == "tab1") {
      dataTable = this.dataSourceDetail1.data.slice();
    }
    if (tab == "tab2") {
      dataTable = this.dataSourceDetail2.data.slice();
    }
    if (tab == "tab3") {
      dataTable = this.dataSourceDetail3.data.slice();
    }

    dataTable.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "material":
          return this.compare(a.material?.name, b.material?.name, isAsc);
        case "note":
          return this.compare(a.note, b.note, isAsc);
        case "warehouse":
          return this.compare(a.warehouse?.name, b.warehouse?.name, isAsc);
        case "soldQuantity":
          return this.compare(
            Number(a.soldQuantity),
            Number(b.soldQuantity),
            isAsc
          );
        case "unitPrice":
          return this.compare(Number(a.unitPrice), Number(b.unitPrice), isAsc);
        case "subTotal":
          return this.compare(Number(a.subTotal), Number(b.subTotal), isAsc);
        case "subTotalBeforeTaxes":
          return this.compare(
            Number(a.subTotalBeforeTaxes),
            Number(b.subTotalBeforeTaxes),
            isAsc
          );
        case "totalSurcharges":
          return this.compare(
            Number(a.totalSurcharges),
            Number(b.totalSurcharges),
            isAsc
          );
        case "totalDiscounts":
          return this.compare(
            Number(a.totalDiscounts),
            Number(b.totalDiscounts),
            isAsc
          );
        case "totalTaxes":
          return this.compare(
            Number(a.totalTaxes),
            Number(b.totalTaxes),
            isAsc
          );
        case "total":
          return this.compare(Number(a.total), Number(b.total), isAsc);
        default:
          return 0;
      }
    });

    if (tab == "tab1") {
      this.dataSourceDetail1.data = dataTable;
    }
    if (tab == "tab2") {
      this.dataSourceDetail2.data = dataTable;
    }
    if (tab == "tab3") {
      this.dataSourceDetail3.data = dataTable;
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  showPopup(event: MouseEvent, detail: OrderDetailAttributes) {
    if (!detail.note || detail.note.trim() === "") return;

    this.popupText = detail.note || null;
    this.popupStyle = {
      top: `${event.clientY + 10}px`,
      left: `${event.clientX}px`,
    };

    this.isPopupVisible = true;
    this.viewContainerRef.createEmbeddedView(this.popupTemplate);
  }

  hidePopupWithDelay() {
    setTimeout(() => {
      this.isPopupVisible = false;
      this.viewContainerRef.clear();
    }, 500);
  }

  closeDetails(): void {
    this.selectedOrder = null;
  }

  formatHour(date: string): string {
    if (date) {
      const d = new Date(date);
      const hours = d.getHours().toString().padStart(2, "0");
      const minutes = d.getMinutes().toString().padStart(2, "0");
      const seconds = d.getSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
    return "--:--:--";
  }

  toggleTravel(travel: string): void {
    // Si el rol ya está seleccionado, lo eliminamos
    if (this.selectedWithTravel.includes(travel)) {
      this.selectedWithTravel = this.selectedWithTravel.filter(
        (r) => r !== travel
      );
    } else {
      // Si no está seleccionado, lo agregamos
      this.selectedWithTravel.push(travel);
    }
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      if (res.data.length === 1) {
        this.UMPActive = res.data[0].UMPActive;
      }
    });
  }

  clearFilters(): void {
    /*this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();*/
    const today = new Date();
    this.dateRange.reset({ start: null, end: null });
    this.dateRangeDelivery.reset({ start: null, end: null });
    this.dateRangeLoad.reset({ start: null, end: null });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.selectedDocumentClass = [];
    this.selectedStatusERP = [];
    this.selectedWithTravel = [];
    this.selectedSeller = "0";
    this.soldToControl.setValue("");
    this.shipToControl.setValue("");
    this.soldToFilterSelected = null;
  }

  synchronizeDates(): void {
    this.selectedStartDate = this.dateRange.get("start")?.value;
    this.selectedEndDate = this.dateRange.get("end")?.value;
  }

  synchronizeDatesDelivery(): void {
    this.selectedStartDateEnd = this.dateRangeDelivery.get("start")?.value;
    this.selectedEndDateEnd = this.dateRangeDelivery.get("end")?.value;
  }

  synchronizeDatesLoad(): void {
    this.selectedStartDateLoad = this.dateRangeLoad.get("start")?.value;
    this.selectedEndDateLoad = this.dateRangeLoad.get("end")?.value;
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: this.type,
    };
    // this.ordersListService.fetchDocumentClasses(dataToFilter).subscribe((res) => {
    //   this.documentClassesList = res.data;
    // })
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
        this.filteredDocumentClasses.next(this.documentClassesList);
      });
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching sellers",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  getListSoldTo(search?): void {
    let dataToSend = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };
    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      this.soldToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  onChangeSoldTo() {
    this.soldToFilterSelected = this.soldToList.find(
      (stl) => stl.id == this.soldToControl.value
    );
    this.shipToControl.setValue("");
    this.getListShipTo();
  }

  getListShipTo(search?): void {
    this.shipToList = [];
    const soldToValue = this.soldToFilterSelected
      ? this.soldToFilterSelected._id
      : null;

    let dataToSend: any = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };

    if (soldToValue) {
      dataToSend.soldToMongoId = soldToValue;
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      this.shipToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  synchronizeOrders(order: OrderAttributes) {
    let dataToSendPost = {
      TripIds: [],
      orderIds: [],
      method: "POST",
    };

    let dataToSendPut = {
      TripIds: [],
      orderIds: [],
      method: "PUT",
    };

    if (order) {
      if (order?.externalKeys?.code) {
        dataToSendPut.orderIds.push(order._id.toString());
      } else {
        dataToSendPost.orderIds.push(order._id.toString());
      }
    } else {
      this.selection.selected.forEach((o) => {
        if (o.externalKeys?.code) {
          dataToSendPut.orderIds.push(o._id.toString());
        } else {
          dataToSendPost.orderIds.push(o._id.toString());
        }
      });
    }

    const requests = [];
    if (dataToSendPost.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPost).toPromise()
      );
    }
    if (dataToSendPut.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPut).toPromise()
      );
    }

    if (requests.length === 0) {
      this.snackBar.open(
        "No se encontraron registros pendientes de sincronizar con ERP.",
        "Cerrar",
        { duration: 5000 }
      );
    }

    Promise.all(requests)
      .then(() => {
        this.snackBar.open("Registro sincronizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      })
      .catch((err) => {
        this.snackBar.open(
          err.error.message || "Error al sincronizar con el ERP.",
          "Cerrar",
          { duration: 5000 }
        );
      });
  }

  getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
    const status = list.find((i) => i.type == type);
    return status?.description || "-";
  }

  // onUpdateOrder(order: OrderAttributes): void {
  //   const dialogRef = this.dialog.open(UpdateOrderComponent, {
  //     panelClass: "form-modal",
  //     data: order,
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result && result.data) {
  //       const dataTemp = this.dataSource.data.slice();
  //       dataTemp.forEach((order) => {
  //         if (String(order._id) == String(result.data._id)) {
  //           order.address = result.data.address;
  //           order.expeditionCondition = result.data.expeditionCondition;
  //           order.note = result.data.note;
  //           order.statusERP = result.data.statusERP;
  //           order.statusId = result.data.statusId;
  //         }
  //       });
  //       this.dataSource.data = dataTemp;
  //       this.cdr.detectChanges();
  //     }
  //   });
  // }

  onUpdateOrder(order: OrderAttributes): void {
    const data =
      this.selection.selected?.length > 0
        ? this.selection.selected // Enviar arreglo
        : order;

    const dialogRef = this.dialog.open(ChangeTripOrderComponent, {
      panelClass: "form-modal",
      data: data,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.address = result.data.address;
            order.expeditionCondition = result.data.expeditionCondition;
            order.note = result.data.note;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        this.cdr.detectChanges();
      }
      if (result) {
        this.getList();
      }
    });
  }

  async getStock(order: OrderAttributes, warehouses: WarehouseAttributes[]) {
    let dataToSend = {
      materialsIds: order.detail
        .filter((od) => od.statusId == StatusEnum.ACTIVE)
        .map((d) => String(d.material._id)),
      unitMeasureIds: [],
      warehouseIds: warehouses.map((w) => String(w._id)),
    };
    const stock: MaterialStockAttributes[] = await this.ordersCreationService
      .fetchStock(dataToSend)
      .toPromise()
      .then((res) => res.data[0].data);

    order.detail.forEach((od) => {
      od["stock"] = stock.filter(
        (s) => String(s.materialId) == String(od.material._id)
      );
      od["stockToValidate"] = this.roundToX(
        od["stock"].find(
          (s: MaterialStockAttributes) =>
            String(s.warehouseId) == String(od.warehouse._id) &&
            String(s.unitOfMeasureId) == String(od.soldUnitOfMeasure._id)
        )?.availableStock ?? 0,
        3
      );
    });
    if (
      this.selectedOrder &&
      String(this.selectedOrder._id) == String(order._id)
    )
      this.dataSourceDetail1.data = this.selectedOrder.detail || [];
    this.cdr.detectChanges();
  }

  async getDocumentClass(order: OrderAttributes) {
    const documentClass: DocumentClassAttributes =
      await this.documentClassService
        .findOne(String(order.class._id))
        .toPromise()
        .then((res) => res.data);
    if (documentClass) order.class = documentClass;
    this.cdr.detectChanges();
  }

  roundToX(value: number, decimals: number) {
    return parseFloat(value.toFixed(decimals));
  }

  openLogModal(element: OrderAttributes) {
    let dataToModal = {
      documentIdentifier: element.serial,
    };
    this.dialog.open(LogModalComponent, {
      width: "90%",
      data: dataToModal,
      disableClose: true,
    });
  }

  validateDataToSynchronize(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "SYNC");
  }

  validateDataToEdit(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "EDIT");
  }

  validateDataToAppOrRejected(order: OrderAttributes) {
    return (
      validateOrdersByAction([order], this.documentClassesList, "APPROVE") ||
      validateOrdersByAction(
        [order],
        this.documentClassesList,
        "APPROVE_GENERATE_NEXT"
      ) ||
      validateOrdersByAction([order], this.documentClassesList, "REJECT")
    );
  }

  validateDataToCopy(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "COPY");
  }

  validateDataToDivide(order: OrderAttributes) {
    return (
      validateOrdersByAction([order], this.documentClassesList, "DIVIDE") &&
      order?.sourceTransactions.length == 0
    );
  }

  //aprobar/rechazar
  openModal(element): void {
    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: {
        element: element,
        requeriment: {
          approve: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "APPROVE"
          ),
          approve_generate: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "APPROVE_GENERATE_NEXT"
          ),
          reject: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "REJECT"
          ),
        },
        type: TypeRejectEnum.ENTREGA,
      },
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .subscribe((result: IUserApprovalResponse | "Close" | undefined) => {
        if (result === undefined || result == "Close") {
        } else {
          if (result) {
            let sendOrder: IUpdateOrder = {
              reasonForRejectionId: result.reasonRejectionId ?? null,
              statusId: result.approve
                ? StatusEnum.ORDER_APPROVED
                : StatusEnum.INACTIVE,
            };

            this.updateAppReje(element, sendOrder);
          }
        }
      });
  }

  updateAppReje(element, result) {
    this.ordersListService.update(element._id, result).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  cloneOrder(element: OrderAttributes, type: string) {
    //type: 'copy', 'divide'
    const dialogRef = this.dialog.open(SelectOrderDetailComponent, {
      data: { order: element, type: type },
      disableClose: true,
      width: "90%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
      }
    });
  }

  compareCodes(element: any): boolean {
    const responsibleCode =
      element.responsibleBusinessPartner?.externalKeys?.code;
    const soldToCode = element.soldTo?.externalKeys?.code;
    return responsibleCode && soldToCode && responsibleCode === soldToCode;
  }

  handleEqualCodes(element: any): void {
    if (this.compareCodes(element)) {
      element.isSamePerson = true;
    } else {
      element.isSamePerson = false;
    }
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  onExportButtonPressed() {
    // const id = 'sales-invoice-list';
    // if (this.exportService.taskIsActive(id)) {
    //   this.exportService.setVisible(true);
    //   return;
    // }
    // this.exportService.createForSalesOrdersList(
    //   this.totalItems,
    //   this.ordersListService.currentFilter,
    //   this.ordersListService.currentFilterData,
    //   ExportRange.CurrentPage,
    //   ExportFileFormat.Excel,
    // ).start();
    /* const dialogRef = this.matDialog.open(ExportDialogComponent);
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.exportService.createForOrderCustomer(
          this.totalItems,
          this.orderCustomer.currentFilter,
          options.range,
          options.format,
        ).start();
      }
    }); */
  }

  downloadSubRouteTemplate() {
    const url = this.ordersListService.getFileTemplateDeliver();
    if (!url) {
      this.snackBar.open("Plantilla no disponible.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    window.open(url);
  }

  private initializeDownloadDay() {
    return {
      deliveryDateTime: new Date(),
      officeId: null,
      routeId: null,
    };
  }

  downloadDayTemplate() {
    this.getOffices();
    this.currentDownloadDay = this.initializeDownloadDay();
    this.dialogDayFile = this.dialog.open(this.fileDayImportDialog, {
      panelClass: "form-modal",
      disableClose: true,
    });
    this.dialogDayFile.afterClosed().subscribe((result) => {
      result;
    });
  }

  private initializeRoute() {
    return {
      deliveryDateTime: new Date(),
      officeId: null,
      routeId: null,
      emissionPointId: null,
    };
  }

  private initializeAll() {
    return {
      deliveryDateTime: new Date(),
    };
  }

  openFileModal(): void {
    this.fetchAllDocumentRange();
    this.getOffices();
    this.getRoutes(null);
    this.currentRoute = this.initializeRoute();
    this.currentAll = this.initializeAll();
    this.dialogRefFile = this.dialog.open(this.fileImportDialog, {
      panelClass: "form-modal",
      disableClose: true,
    });
    this.dialogRefFile.afterClosed().subscribe((result) => {
      result;
    });
  }

  private getOffices(): void {
    this.salesOfficeService.findToComboBox().subscribe((res) => {
      this.salesOfficeList = res.data;
      this.filterSalesOfficeList = this.salesOfficeList.slice();
    });
  }

  changueOptionsSalesOffice(event) {
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.filterSalesOfficeList = this.salesOfficeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterSalesOfficeList = this.salesOfficeList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  changeSalesOffice(type?: string) {
    this.routeList = [];
    this.filterRouteList = [];
    this.getRoutes(
      type == "R"
        ? this.currentRoute.officeId
        : this.currentDownloadDay.officeId
    );
  }

  private getRoutes(salesOffice): void {
    const isSalesOffice = this.salesOfficeList.find((s) => s.id == salesOffice);
    let salesOfficeId = isSalesOffice ? isSalesOffice._id : null;

    this.subRouteService.findToComboBox(salesOfficeId).subscribe((res) => {
      this.routeList = res.data;
      this.filterRouteList = this.routeList.slice();
    });
  }

  changueOptionsRoute(event) {
    if (!this.routeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.filterRouteList = this.routeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterRouteList = this.routeList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  private fetchAllDocumentRange(): void {
    this.documentRangeService.findToComboBox(this.type).subscribe({
      //entrega
      next: (res) => {
        const uniqueEmissionPoints = new Map();
        res.data.forEach((item) => {
          if (
            item.emissionPoint &&
            !uniqueEmissionPoints.has(item.emissionPoint._id)
          ) {
            uniqueEmissionPoints.set(
              item.emissionPoint._id,
              item.emissionPoint
            );
          }
        });

        const emissionPointIds = Array.from(uniqueEmissionPoints.keys());
        if (emissionPointIds.length > 0) {
          this.fetchAllEmissionPoint(emissionPointIds);
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching document range",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllEmissionPoint(emmisionPointIds): void {
    this.emisionPointService.findToComboBox(emmisionPointIds).subscribe({
      next: (res) => {
        this.emissionPointList = res.data;
        this.listFilteremissionPointList = this.emissionPointList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching emission point",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsEmissionPoint(event) {
    if (!this.emissionPointList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilteremissionPointList = this.emissionPointList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilteremissionPointList = this.emissionPointList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  today() {
    return new Date();
  }

  fetchDownloadDay(): void {
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
    };

    let dataFilter = {
      type: DocumentTypeEnum.PEDIDO,
      creationDateTime: this.currentDownloadDay.deliveryDateTime,
      office: this.currentDownloadDay.officeId,
      route: this.currentDownloadDay.routeId,
    };

    this.ordersListService
      .findAllDownloadWithCount(options, dataFilter)
      .subscribe({
        //this.orderCustomerService.findAllDownloadWithCount
        next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
          this.totalItemsDay = res?.data?.pageInfo?.[0]?.total ?? 0;
          if (this.totalItemsDay > 0) {
            this.onExportDownloadDay();
          } else {
            this.snackBar.open("No hay registros para exportar", "Cerrar", {
              duration: 3000,
            });
          }
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching delivery list",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  async handleFileInput(event) {
    this.aux_file = true;
    this.fileToUpload = event.target.files[0];
    if (this.fileToUpload) {
      if (
        this.fileToUpload.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.snackBar.open("Ingrese solo de tipo .xlsx", "Cerrar", {
          duration: 3000,
        });
      }
    } else {
      this.aux_file = false;
    }
  }

  async handleFileInputAll(event) {
    this.aux_file_all = true;
    this.fileToUploadAll = event.target.files[0];
    if (this.fileToUploadAll) {
      if (
        this.fileToUploadAll.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.snackBar.open("Ingrese solo de tipo .xlsx", "Cerrar", {
          duration: 3000,
        });
      }
    } else {
      this.aux_file_all = false;
    }
  }

  onConfirmImportFile(fileInput: HTMLInputElement, type: string) {
    if (type == "R" && this.currentRoute.deliveryDateTime == null) {
      //this.currentRoute.emissionPointId == null ||
      return;
    }

    if (type == "A" && this.currentAll.deliveryDateTime == null) {
      return;
    }

    if (this.fileToUpload || this.fileToUploadAll) {
      if (!this.authService.user) {
        return;
      }

      let send = {
        file: type == "R" ? this.fileToUpload : this.fileToUploadAll,
        deliveryDateTime:
          type == "R"
            ? new Date(this.currentRoute.deliveryDateTime).toISOString()
            : new Date(this.currentAll.deliveryDateTime).toISOString(),
        user: null, // this.authService.user.username,
        //company: environment.companyId,
        //emissionPoint: type == 'R' ? this.currentRoute.emissionPointId: null,
        operation: type == "R" ? 1 : 2,
      };
      let formdata = new FormData();
      for (let key in send) {
        formdata.append(key, send[key]);
      }

      this.ordersListService.importFile(formdata).subscribe({
        next: (res: any) => {
          this.snackBar.open("Archivo subido con éxito", "Cerrar", {
            duration: 3000,
          });
          if (type == "R") {
            this.aux_file = false;
            this.fileToUpload = null;
          } else {
            this.aux_file_all = false;
            this.fileToUploadAll = null;
          }
          this.dialogRefFile.close(true);
          this.getList();
          fileInput.value = "";
        },
        error: (err) => {
          if (type == "R") {
            this.aux_file = false;
            this.fileToUpload = null;
          } else {
            this.aux_file_all = false;
            this.fileToUploadAll = null;
          }
          this.snackBar.open(
            err.error.message || "Error al subir el registro",
            "Cerrar",
            { duration: 3000 }
          );
          this.dialogRefFile.close(true);
          fileInput.value = "";
        },
      });
    }
  }

  onExportDownloadDay() {
    this.dialogDayFile.close(true);
    if (!this.orderDeliveryCustomerExport.canStartTask()) return;

    const filterData = {
      type: DocumentTypeEnum.PEDIDO,
      creationDateTime: this.currentDownloadDay.deliveryDateTime,
      office: this.currentDownloadDay.officeId,
      route: this.currentDownloadDay.routeId,
    };

    this.orderDeliveryCustomerExport.export(
      ExportFileFormat.Excel,
      ExportRange.CurrentPage,
      this.totalItemsDay,
      this.pageSize,
      this.pageIndex,
      filterData
    );
  }

  goToTravel(element: OrderAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  fetchSoldToName = (soldtoId: string): string => {
    const foundSoldTo = this.soldToList.find(
      (soldTo) => soldTo.id === soldtoId
    );
    if (foundSoldTo) {
      return foundSoldTo.name;
    }
    return "";
  };

  fetchShipToName = (shipToId: string): string => {
    const foundShipTo = this.shipToList.find(
      (shipTo) => shipTo.id === shipToId
    );
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return "";
  };

  getTooltip(el: OrderAttributes): string {
    const rutaCode =
      el?.subRoute?.externalKeys?.code ?? el?.subRoute?.model ?? "-";
    const rutaName = el?.subRoute?.name ?? "-";
    const user = el?.user?.user_login?.username ?? "-";

    const person = el?.responsibleBusinessPartner?.personNumber
      ? `${el.responsibleBusinessPartner.personNumber} - `
      : "";
    const bpCode = el?.responsibleBusinessPartner?.externalKeys?.code ?? "";
    const bpName = el?.responsibleBusinessPartner?.name ?? "-";

    return [
      `Ruta: ${rutaCode} | ${rutaName}`,
      `Usuario: ${user}`,
      `Responsable: ${person}${bpCode} ${bpName}`.trim(),
    ].join("\n");
  }

  hasTrip(element: OrderAttributes): boolean {
    return !!element?.trip?.id;
  }
}
